export const SET_INTERNET_STATUS = "SET_INTERNET_STATUS"
export const SET_FORCE_OFFLINE = "SET_FORCE_OFFLINE"
export const REMOVE_FORCE_OFFLINE = "REMOVE_FORCE_OFFLINE"